import { Box, Button, CircularProgress, Stack } from "@mui/material";
import React, { useState } from "react";
import BroadcastIcon from "../../../images/broadcast.svg";
import { get } from "aws-amplify/api";
import PodcastCard from "./PodcastCard";

const Section3 = ({
  podcasts,
  setActivePodcast,
  iframeRef,
  loader,
  setPodcasts,
}) => {
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);

  const handleSetActivePodcast = (podcast) => {
    setActivePodcast(podcast);

    iframeRef.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };

  const handleLoadMore = async () => {
    setLoadMoreLoader(true);

    try {
      const newPodcasts = await (
        await get({
          apiName: "community",
          path: `/spotify/episodes?limit=5&offset=${podcasts.offset + 5}`,
        }).response
      ).body.json();

      setPodcasts({
        ...newPodcasts,
        items: [...podcasts.items, ...newPodcasts.items],
      });
    } catch (e) {
      console.error(e);
    }

    setLoadMoreLoader(false);
  };

  return (
    <Stack
      sx={{
        pt: "80px",
        pb: "40px",
        px: "20px",
        maxWidth: "1000px",
        width: "100%",
        alignSelf: "center",
      }}
      gap={4}
    >
      {loader ? (
        <CircularProgress
          sx={{ alignSelf: "center", mb: "40px" }}
          size="150px"
          thickness={2.5}
        />
      ) : (
        <>
          <Box
            component="img"
            src={BroadcastIcon}
            sx={{ height: "35px", width: "105px" }}
          />
          <Stack gap={3}>
            {podcasts.items.map((podcast) => (
              <PodcastCard
                key={podcast.id}
                podcast={podcast}
                handleSetActivePodcast={handleSetActivePodcast}
              />
            ))}
          </Stack>
          {podcasts.items.length < podcasts.total && (
            <>
              {loadMoreLoader ? (
                <CircularProgress sx={{ alignSelf: "center" }} />
              ) : (
                <Button
                  sx={{ alignSelf: "center", textTransform: "uppercase" }}
                  onClick={handleLoadMore}
                >
                  Load More
                </Button>
              )}
            </>
          )}
        </>
      )}
    </Stack>
  );
};

export default Section3;
